import React from "react";
import { Container, Row, Col } from "reactstrap";
import ResultSideBar from "./sideBar";
import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { ResultBarCard } from "../../components/card";
import ResultScore from "../../components/resultScore";
import cx from "classnames";
class FinalResult extends React.Component {
  render() {
    const gameData = this.props.gameReducer;
    let room = gameData.roomObj;
    let wrongWords = [];
    let rightWords = [];
    let resultWord = "AWESOME";
    let resultValue = "";
    let finalScore = "";

    if (room) {
      if (room.game_state && room.game_state.status) {
        if (!room.active_game) {
          return <Redirect to={"/"} />;
        }
        if (
          room.game_state.status === "Clues" ||
          room.game_state.status === "Evaluating" ||
          room.game_state.status === "Guessing" ||
          room.game_state.status === "Judging"
        )
          return <Redirect to={"/game"} />;
        if (room.game_state.status === "Joining") return <Redirect to={"/"} />;

        if (room.game_state.status === "Result") {
          return <Redirect to={"/result"} />;
        }
      }
    }
    let gif = "https://media0.giphy.com/media/bqXMrwkWhAbrV0Z0dG/giphy.gif";
    if (gameData) {
      if (gameData?.roomObj?.game_state?.wrong_words) {
        wrongWords = gameData.roomObj.game_state.wrong_words;
      }
      if (gameData?.roomObj?.game_state?.right_words) {
        rightWords = gameData.roomObj.game_state.right_words;
      }
      if (gameData?.roomObj?.game_state?.game_outputs) {
        if (gameData.roomObj.game_state.game_outputs.tabletop_text_bottom) {
          resultWord =
            gameData.roomObj.game_state.game_outputs.tabletop_text_bottom;
          if (gameData.roomObj.game_state.game_outputs.tabletop_text_top) {
            resultValue =
              gameData.roomObj.game_state.game_outputs.tabletop_text_top;
            let index = resultValue.indexOf(" ", resultValue.indexOf(" ") + 1);
            if (index >= 0) {
              finalScore = resultValue.substring(index + 1);
            }
            gif = gameData.roomObj.game_state.game_outputs.tabletop_url;
          }
        }
      }
    }
    let groupScoreValue = `FINAL SCORE: ${rightWords.length}/${
      rightWords.length + wrongWords.length
    }`;

    if (resultValue !== "") {
      groupScoreValue = resultValue;
    }
    return (
      <>
        <div
          className={cx("finalResult h-100 ", {
            twFinalResultWrapper:
              this.props.gameReducer.roomObj.game_code === "TW"
          })}
        >
          <Container fluid className="px-0">
            <Row>
              <Col md={4} lg={3}>
                <ResultSideBar rightWords={rightWords} gameData={gameData} />
              </Col>
              <Col md={4} lg={6} className="px-md-0">
                <div className="bg-g-theme l-6  view h-100 d-flex align-items-center">
                  <div className="w-100 h-100">
                    <ResultBarCard text={resultWord} finalScore={finalScore} />
                    {/* <div className="resultView">
                      <img alt="" src={gif} />
                    </div> */}
                    <ResultScore score={groupScoreValue} />
                  </div>
                </div>
              </Col>
              <Col md={4} lg={3}>
                <ResultSideBar
                  wrongWords={wrongWords}
                  gameData={gameData}
                  isRightSideBar
                />
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, null)
)(FinalResult);
